// client/src/components/collab/CollaboratorsPanel.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { sessionRequestConfig } from "../../services/sessionLocal";

/** Try a list of request functions until one succeeds. */
const fetchFirst = async (attempts) => {
  let lastErr;
  for (const attempt of attempts) {
    try { return await attempt(); } catch (e) { lastErr = e; }
  }
  throw lastErr || new Error("All requests failed");
};

export default function CollaboratorsPanel({ tenantIdForRoutes, eventId, canManage }) {
  const [rows, setRows] = useState([]);
  const cfg = sessionRequestConfig();

  const load = async () => {
    try {
      const { data } = await fetchFirst([
        () => axios.get(`/api/collab/events/${eventId}/collaborators`, cfg),
        () => axios.get(`/api/collab/${tenantIdForRoutes}/events/${eventId}/collaborators`, cfg),
      ]);
      const arr = Array.isArray(data) ? data : data?.collaborators || data?.rows || [];
      setRows(arr);
    } catch {
      setRows([]);
    }
  };

  useEffect(() => { if (eventId) load(); /* eslint-disable-next-line */ }, [eventId]);

  const revoke = async (sharedWithTenantId) => {
    try {
      await fetchFirst([
        () => axios.post(`/api/collab/events/${eventId}/revoke`, { sharedWithTenantId }, cfg),
        () => axios.post(`/api/collab/${tenantIdForRoutes}/events/${eventId}/revoke`, { sharedWithTenantId }, cfg),
      ]);
    } catch {}
    load();
  };

  return (
    <div className="mt-6 rounded-xl border border-black/10 dark:border-white/10 p-3">
      <div className="font-semibold mb-2 text-neutral-800 dark:text-neutral-100">Collaborators</div>
      {rows.length === 0 ? (
        <div className="text-sm opacity-70">No collaborators yet.</div>
      ) : (
        <ul className="space-y-2">
          {rows.map((r) => {
            const id = r.shared_with_tenant_id ?? r.tenantId ?? r.sharedWithTenantId;
            const displayName = r.tenantName || r.name || `Tenant #${id}`;
            return (
              <li key={id} className="flex items-center justify-between gap-3 text-sm">
                <div className="flex items-center gap-3">
                  <span className="font-semibold">{displayName}</span>
                  <span className="px-2 py-0.5 rounded bg-black/5 dark:bg-white/10">{r.role}</span>
                  <span className="opacity-70">{r.status || "active"}</span>
                </div>
                {canManage && (
                  <button
                    onClick={() => revoke(id)}
                    className="px-2 py-1 rounded border hover:bg-black/5 dark:hover:bg-white/10"
                  >
                    Revoke
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
